<form>
    <div>
        <mat-card class="mat-elevation-z0 mb-4 advanced-search">
            <div class="row align-items-center mb-3 pb-2">
                <div class="col-10">
                    <div class="d-flex align-items-center">
                        <mat-icon class="material-icons-outlined me-3 mat-icon-31" mat-list-icon>tune</mat-icon>
                        <span class="font-semibold">
                            Match all of the following criteria
                        </span>
                    </div>
                </div> 
                <div class="col-2">
                    <button class="drawer-close-btn mat-elevation-z0" (click)="jobDashBoard()" mat-mini-fab
                        aria-label="Close">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            <div class="d-flex align-items-center mb-2">
                <div class="col-4 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Job title / Job number</mat-label>
                        <input type="text" matInput placeholder="Please type Job title or Job number"
                            name="jobIdentification" [(ngModel)]="searchModel.selectedJobIdentification" />
                    </mat-form-field>
                </div>

                <div class="col-2 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Type</mat-label>
                        <mat-select [(ngModel)]="searchModel.selectedJobType" 
                            name="type" multiple>
                            <mat-option *ngFor="let jobType of searchModel.jobTypes" [value]="jobType" (click)="onJobTypeChange(jobType)">
                                {{jobType.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-2 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Status</mat-label>
                        <mat-select [(ngModel)]="searchModel.selectedStatus" name="status" multiple
                             placeholder="Select type first">
                            <mat-option *ngFor="let status of searchModel.statuses" [value]="status" (click)="onStatusChange(status)">{{status.text}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Posted date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start date" [(ngModel)]="searchModel.posted_Start"
                                name="posted_Start">
                            <input matEndDate placeholder="End date" [(ngModel)]="searchModel.posted_End"
                                name="posted_End">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div class="w-95 ms-2">
                    <button mat-button mat-raised-button (click)="OnReset(deactivatedPropertyInput,snoozedJobsInput)"
                        class="common-button light-gray mat-elevation-z0 w-100 no-min-width">Clear</button>
                </div>
            </div>

            <div class="d-flex align-items-center mb-2">
                <div class="col-4 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Trade</mat-label>
                        <div class="custom-scroller">
                            <mat-chip-list #chipListTradee>
                                <mat-chip *ngFor="let tradeeChip of searchModel.tradeesChips"
                                    (removed)="OnRemoveTradeeChip(tradeeChip)">
                                    {{tradeeChip.text}}
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <input matInput placeholder="Enter provider name or business name"
                                    [matAutocomplete]="autoTradee" [formControl]="tradeeControl"
                                    (keyup)="OnTradeNameFragmentChanged($event.target)"
                                    [matChipInputFor]="chipListTradee"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="OnAddTradeeChip($event)" #tradeeInput
                                    [(ngModel)]="TradeNameFragment" />
                            </mat-chip-list>
                        </div>
                        <mat-autocomplete autoActiveFirstOption #autoTradee="matAutocomplete"
                            (optionSelected)="OnSelectedTradee($event)">
                            <mat-option *ngFor="let tradee of tradees$ | async" [value]="tradee">
                                {{tradee.fullNameDisplay}}
                            </mat-option>
                        </mat-autocomplete>

                        <mat-card class="mat-elevation-z0 font-11 px-0 pb-0 pt-2 text-red"
                            *ngIf="!loadingTradees && TradeNameFragment && tradees && tradees.length==0">No trades
                            found.
                            "{{TradeNameFragment}}"...
                            ...</mat-card>
                    </mat-form-field>

                </div>

                <div class="col-2 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Service type</mat-label>
                        <div class="custom-scroller">
                            <mat-chip-list #chipList>
                                <mat-chip *ngFor="let servType of searchModel.serviceTypesChips"
                                    (removed)="OnRemoveServiceTypeChip(servType)" style="
                                    height: auto;">
                                    {{servType.text}}
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <input placeholder="select a service type" [matAutocomplete]="autoServiceType"
                                    [formControl]="ServiceTypeControl" [matChipInputFor]="chipList"
                                    (keyup)="OnServiceTypeFragmentChanged($event.target)"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="OnAddServiceTypeChip($event)" #serviceTypeInput
                                    [(ngModel)]="ServiceTypeFragment" />
                            </mat-chip-list>
                        </div>
                        <mat-autocomplete autoActiveFirstOption #autoServiceType="matAutocomplete"
                            (optionSelected)="OnSelectedServiceType($event)">
                            <mat-option *ngFor="let serviceType of serviceTypes$ | async" [value]="serviceType">
                                {{serviceType.primaryJobType?.name}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-card class="mat-elevation-z0 font-11 px-0 pb-0 pt-2 text-red"
                            *ngIf="!loadingServiceType && serviceTypeInput.value">No service
                            types found.
                            ..."{{ServiceTypeFragment}}"
                            ...</mat-card>
                    </mat-form-field>

                </div>
                <div class="col-2 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Urgency</mat-label>
                        <mat-select [(ngModel)]="searchModel.selectedUrgency" name="urgencyType">
                            <mat-option *ngFor="let urgencyType of searchModel.urgencyTypes" [value]="urgencyType">
                                {{urgencyType.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Deadline</mat-label>
                        <mat-date-range-input [rangePicker]="pickerr">
                            <input matStartDate placeholder="Start date" name="dueDateStart"
                                [(ngModel)]="searchModel.deadLine_Start">
                            <input matEndDate placeholder="End date" name="dueDateEnd"
                                [(ngModel)]="searchModel.deadLine_end">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="pickerr"></mat-datepicker-toggle>
                        <mat-date-range-picker #pickerr></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div class="w-95 ms-2">
                    <button mat-button mat-raised-button (click)="OnApplySearchCriterias()"
                        class="common-button black mat-elevation-z0 w-100 no-min-width">Apply</button>
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div class="col-4 me-3 searchProperty">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Property</mat-label>
                        <div class="custom-scroller">
                            <mat-chip-list #chipListProperty>
                                <mat-chip *ngFor="let propertyChip of searchModel.propertyChips"
                                    (removed)="OnRemovePropertyChip(propertyChip)">
                                    {{propertyChip.text}}
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <input matInput placeholder="Enter property address"
                                    [matAutocomplete]="autoProperty" [formControl]="propertyControl"
                                    (keyup)="OnPropertyFragmentChanged($event.target)"
                                    [matChipInputFor]="chipListProperty"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="OnAddPropertyChip($event)" #propertyInput
                                    [(ngModel)]="PropertyFragment" />
                            </mat-chip-list>
                        </div>
                        <mat-autocomplete autoActiveFirstOption #autoProperty="matAutocomplete"
                            (optionSelected)="OnSelectedProperty($event)">
                            <mat-option *ngFor="let property of properties$ | async" [value]="property">
                               <div class="deactivate-text-label d-flex align-items-center justify-content-between">
                                <span class="float-start font-poppins font-13">{{property.address}}</span>
                                <span *ngIf="property.isDeactivated" matBadgeSize="small" class="float-end common-tag red small rounded mx-0 my-3" style="line-height: 20px">Deactivated</span>
                               </div>
                            </mat-option>
                        </mat-autocomplete>

                        <mat-card class="mat-elevation-z0 font-11 px-0 pb-0 pt-2 text-red"
                            *ngIf="!loadingProperties && PropertyFragment && properties && properties.length==0">No properties found.
                        </mat-card>
                    </mat-form-field>

                </div>
                <div class="col-2 me-3">
                    <mat-form-field appearance="outline" class="w-100 pb-0">
                        <mat-label>Organization view</mat-label>
                        <mat-select [(ngModel)]="searchModel.selectedTeamUsers" name="teamusers" multiple
                             placeholder="Select type first">
                            <mat-option *ngFor="let user of teamUsers" [value]="user" (click)="onChangeTeamUser(user)">{{user.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-2 me-3">
                    <mat-checkbox #deactivatedPropertyInput (change)="includeDeactivatedPropertiesCheck()">
                        <span>Show deactivated properties</span>
                    </mat-checkbox>
                </div>
                <div class="col-2 me-3" *ngIf="snoozedJobsCheckboxVisible">
                    <mat-checkbox [checked]="isSnoozedJob"  #snoozedJobsInput (change)="snoozedJobsCheck()">
                        <span>Show only snoozed jobs</span>
                    </mat-checkbox>
                </div>
            </div>
        </mat-card>
    </div>
</form>